import React, { useState, useEffect } from 'react'
import { Backdrop, CircularProgress, Grid, Typography } from '@mui/material'
import { useParams } from 'react-router-dom'
import useStyles from './useStyle'
import { useDispatch } from 'react-redux'
import BreadcrumbsComponent from './Breadcrumbs/Breadcrumbs'
import InfoIcon from '@mui/icons-material/Info'
import {
  getAllUserGrantedAppRole,
  getApplicationInstanceEAuthz,
  getUserApplicationInstance
} from '../../../redux/actions/eAuthz'
import { getUserForOrganization } from '../../../redux/actions/Organizations'
import { getAllUsersOfSuborganizations } from '../../../redux/actions/Suborganizations'
import DisabledUsersTable from './DisabledUsers/TableNavigable'
import EnabledUsersTable from './EnabledUsers/TableNavigable'

export default function UsersByInstance () {
  const { id } = useParams()
  const dispatch = useDispatch()
  const classes = useStyles()
  const [loading, setLoading] = useState(false)
  const [usersEnabled, setusersEnabled] = useState([])
  const [usersDisabled, setusersDisabled] = useState([])
  const [usersRolesInstance, setusersRolesInstance] = useState([])
  const [usersInstance, setusersInstance] = useState([])

  const getusersRolesInstance = async () => {
    return await dispatch(getAllUserGrantedAppRole(id))
  }
  const getusersInstance = async () => {
    return await dispatch(getUserApplicationInstance(id))
  }
  const getUsersOrganization = async (organizationId) => {
    return await dispatch(getUserForOrganization(organizationId))
  }
  const getUsersSuborganization = async (suborganizationId) => {
    return await dispatch(getAllUsersOfSuborganizations(suborganizationId))
  }
  const validateUsers = (
    userSuborganization,
    usersOrganization,
    usersInstance
  ) => {
    const usersFilterSuborg = usersOrganization.filter((user) =>
      userSuborganization.find(
        (userSuborg) => userSuborg.user?.userId === user.userId
      )
    )
    const enabledUsers = usersFilterSuborg.filter((user) =>
      usersInstance.find((userinstance) => userinstance.userId === user.userId)
    )
    setusersEnabled(enabledUsers)
    // no existe en la suborganizacion
    const usersSuborgDisable = usersOrganization.filter(
      (user) =>
        !userSuborganization.find(
          (userSuborg) => userSuborg.user.userId === user.userId
        )
    )

    // no existe para la instancia y si en la suborg
    const usersNotEnabledInstance = usersFilterSuborg.filter(
      (user) =>
        !usersInstance.find(
          (userinstance) => userinstance.userId === user.userId
        )
    )

    const usersDisabled = usersSuborgDisable.concat(usersNotEnabledInstance)

    setusersDisabled(Array.from(new Set(usersDisabled)))
  }
  const getUserRole = (userId) => {
    return usersRolesInstance.find(
      (userinstance) => userinstance.userId === userId
    )
  }
  const getuserInstance = (userId) => {
    return usersInstance.find((userinstance) => userinstance.userId === userId)
  }

  const getInstance = async () => {
    const instance = await dispatch(getApplicationInstanceEAuthz(id))
    if (instance) {
      const usersRolesInstance = await getusersRolesInstance()
      setusersRolesInstance(usersRolesInstance)

      const usersInstance = await getusersInstance()
      if (usersInstance?.applicationInstances) {
        setusersInstance(usersInstance.applicationInstances)
      }

      const usersorganization = await getUsersOrganization(
        instance.organizationId
      )
      const userSuborg = await getUsersSuborganization(
        instance.baseSuborganizationId
      )

      validateUsers(
        userSuborg,
        usersorganization,
        usersInstance?.applicationInstances
          ? usersInstance.applicationInstances
          : []
      )
    }
  }

  useEffect(async () => {
    setLoading(true)
    await getInstance()
    setLoading(false)
  }, [id])

  return (
    <div className={classes.root}>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <BreadcrumbsComponent name={'usuarios'} />
      <div className={classes.boxtitle}>
        <Typography className={classes.title}>
          Usuarios asociados a Mi Estudio
        </Typography>
      </div>
      <div className={classes.boxSubTitle}>
        <InfoIcon
          style={{ fontSize: '2rem', color: '#00a78f', marginLeft: 10 }}
        />
        <Typography className={classes.subtitle}>
          En la siguiente sección podrá gestionar los usuarios asociados a la
          organización que están habilitados y no habilitados para utilizar la
          aplicación Mi Estudio.
        </Typography>
      </div>
      <Grid container className={classes.boxDetails}>
        <Grid item xs={12}>
          <Typography
            style={{
              fontSize: 20,
              fontWeight: 'bold',
              color: '#04695a',
              paddingLeft: 10
            }}
          >
            Usuarios asociados
          </Typography>
        </Grid>
      </Grid>
      <div className={classes.boxTable}>
        <EnabledUsersTable
          rows={usersEnabled}
          setLoading={setLoading}
          getUserRole={getUserRole}
          getuserInstance={getuserInstance}
        />
      </div>
      <Grid
        container
        className={classes.boxDetails}
        style={{ marginTop: '4%' }}
      >
        <Grid item xs={12}>
          <Typography
            style={{
              fontSize: 20,
              fontWeight: 'bold',
              color: '#660c0c',
              paddingLeft: 10
            }}
          >
            Usuarios no asociados
          </Typography>
        </Grid>
      </Grid>
      <div className={classes.boxTable} style={{ marginBottom: '5vh' }}>
        <DisabledUsersTable
          rows={usersDisabled}
          setLoading={setLoading}
          getuserInstance={getuserInstance}
        />
      </div>
    </div>
  )
}
